module.exports = __webpack_public_path__ + "img/nl_Ecran 2.f599e158.png";